import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.init({
	debug: false,
	defaultNS: ["translations"],
	lng: "es",
	fallbackLng: "es",
	ns: ["translations"],
	resources: messages,
	interpolation: {
		escapeValue: false, // React already escapes — double-escape turns / into &#x2F;
	},
});

export { i18n };
